import * as api from "./api/index";

export const checkDataPresentService = async (clientId) => {
  try {
    const { data: res } = await api.checkForData(clientId);
    return {
      data: res?.data ?? null,
      error: res?.error || null,
    };
  } catch (err) {
    const errMsg = err?.data?.error || "Unable to check client data status";
    return { error: errMsg };
  }
};
